module.exports = __webpack_public_path__ + "static/media/15UN-Habitat16.787de283.jpg";